// extracted by mini-css-extract-plugin
module.exports = {"defaultLoading":"DefaultLoading_defaultLoading__WeJJD base-styles_coloredText__33MPY"};